export const clickTile = (number) => ({
  type: "CLICK_TILE",
  number,
});
export const clickOp = (op) => ({
  type: "CLICK_OPERATOR",
  op,
});
export const undo = () => ({
  type: "UNDO",
});
export const redo = () => ({
  type: "REDO",
});
export const reset = () => ({
  type: "RESET",
});
export const addSolution = (solution) => ({
  type: "ADD_SOLUTION",
  solution,
});
export const loadSolutions = (solutions) => ({
  type: "LOAD_SOLUTIONS",
  solutions,
});
export const newGame = () => ({
  type: "NEW_GAME",
});
export const loadGame = (target, grid) => ({
  type: "LOAD_GAME",
  target,
  grid,
});
export const toggleHowTo = (showHowTo) => ({
  type: "TOGGLE_HOW_TO",
  showHowTo,
});
export const toggleTitleScreen = () => ({
  type: "TOGGLE_TITLE_SCREEN",
});
export const screenResize = (width, height) => ({
  type: "SCREEN_RESIZE",
  width,
  height,
});
export const setEquationDiv = (div) => ({
  type: "SET_EQUATION_DIV",
  div,
});
export const setGridSize = (cols, rows) =>
  rows === undefined
    ? {
        type: "SET_GRID_SIZE",
        size: cols,
      }
    : {
        type: "SET_GRID_SIZE",
        cols,
        rows,
      };
export const changeTab = (tabIndex) => ({
  type: "CHANGE_TAB",
  tabIndex,
});
export const reviewShown = (reviewShown) => ({
  type: "REVIEW_SHOWN",
  reviewShown,
});
export const setNewGridMenu = (newGridMenu) => ({
  type: "SET_NEW_GRID_MENU",
  newGridMenu,
});
export const setAppTheme = (theme) => ({
  type: "SET_APP_THEME",
  theme,
});
/*
export const refToGrid = (grid) => {
  console.log(grid);
  return {
    type: 'SET_GRID_DIMENSIONS',
    gridWidth: (grid !== null ? grid.offsetWidth : 0),
    gridHeight: window.innerHeight - 270,
  };
};
*/
